
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import { SweetAlertResult } from 'sweetalert2';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import { confirmSwal } from '@/helper/swals';
    import Terminart from '@/types/Terminart';
    import { VForm } from '@/types/Components';
    import { DeleteTerminartPayload, TerminartenFilter, UpdateTerminartPayload } from '@/store/terminarten';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('terminarten', ['loaders']),
            ...mapState('authentication', ['impfstelle_id']),
        },
        methods: {
            ...mapActions('terminarten', ['updateTerminart', 'deleteTerminart']),
        },
    })
    export default class TerminartenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() terminart!: Terminart;
        @Prop() filter!: TerminartenFilter;

        public $refs!: {
            form: VForm;
        };

        public updateTerminart!: (payload: UpdateTerminartPayload) => void;
        public deleteTerminart!: (payload: DeleteTerminartPayload) => void;

        public colorMenu = false;
        public colorTextMenu = false;

        public get colorSwatchStyle(): Partial<CSSStyleDeclaration> {
            return {
                backgroundColor: this.terminart.color as string,
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                border: '0.1pt solid ' + (this.colorTextMenu ? 'white' : 'black'),
                borderRadius: this.colorMenu ? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out',
                marginBottom: '3px',
            };
        }

        public get colorTextSwatchStyle(): Partial<CSSStyleDeclaration> {
            return {
                backgroundColor: this.terminart.textcolor as string,
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                border: '0.1pt solid ' + (this.colorTextMenu ? 'white' : 'black'),
                borderRadius: this.colorTextMenu ? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out',
                marginBottom: '3px',
            };
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateTerminart({ terminart: this.terminart, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Terminart endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteTerminart({ terminart: this.terminart, filter: this.filter });
                    }
                });
        }
    }
